import { object, func } from 'prop-types'
import isEmpty from 'lodash/isEmpty'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import interceptUpdater from 'coact-utils/interceptUpdater'


import HeadEditorView from './HeadEditor'

const stringToLength = (value, len, ch) => {
  const lenth = parseInt(len, 10)
  let character = ch
  if (ch === undefined) character = ' '

  let i
  let str = value
  for (i = str.length; i < len; i++) {
    str = character + str
  }
  return str.slice(0, lenth)
}

const toLen = (num, len, ch) => {
  const str = `${''}${num}`
  return stringToLength(str, len, ch)
}

const diopterToDegree = function (value) {
  const floatValue = parseFloat(value)
  if (isNaN(floatValue)) return ''
  if (floatValue > 0 && floatValue < 1) return `+${toLen(parseInt(floatValue * 100, 10), 3, '0')}`
  else if (floatValue >= 1) return `+${parseInt(floatValue * 100, 10)}`
  else if (floatValue < 0 && floatValue > -1) {
    return `-${toLen(parseInt(floatValue * -100, 10), 3, '0')}`
  } else if (floatValue <= -1) return `-${parseInt(floatValue * -100, 10)}`
  else if (floatValue === 0) return '+000'
  return floatValue
}


const HeadEditor = scope(
  consumeProps({
    value: object,
    onChange: func.isRequired,
  }),

  interceptUpdater('onChange', () => (value, oldValue) => {
    const {
      brandRef: brandRefOrigin,
      orderCode: orderCodeOrigin,
      refractiveIndex: refractiveIndexOrigin,
      design: designOrigin,
      coating: coatingOrigin,
      storageType: storageTypeOrigin,
      sphereMax: SMaxOrigin,
      sphereMin: SMinOrigin,
      cylinderMin: CMinOrigin,
      SCMax: SCMaxOrigin,
      SCMin: SCMinOrigin,
    } = value
    const {
      brandRef: oldBrandRefOrigin,
      orderCode: oldOrderCodeOrigin,
      refractiveIndex: oldRefractiveIndexOrigin,
      design: oldDesignOrigin,
      coating: oldCoatingOrigin,
      storageType: oldStorageTypeOrigin,
      sphereMax: oldSMaxOrigin,
      sphereMin: oldSMinOrigin,
      cylinderMin: oldCMinOrigin,
      SCMax: oldSCMaxOrigin,
      SCMin: oldSCMinOrigin,
    } = oldValue

    const brandRef = brandRefOrigin || { }
    const orderCode = orderCodeOrigin || ''
    const refractiveIndex = refractiveIndexOrigin || ''
    const design = designOrigin || ''
    const coating = coatingOrigin || ''
    const storageType = storageTypeOrigin || ''
    const SMax = diopterToDegree(SMaxOrigin || '')
    const SMin = diopterToDegree(SMinOrigin || '')
    const CMin = diopterToDegree(CMinOrigin || '')
    const SCMax = diopterToDegree(SCMaxOrigin || '')
    const SCMin = diopterToDegree(SCMinOrigin || '')

    const brandRefKey = isEmpty(brandRef) ? '' : brandRef.key
    const brandName = (brandRefKey.split('-')[1]) ? brandRefKey.split('-')[1] : ''

    let generatedName = [brandName, refractiveIndex, design, coating, storageType].join('-')
    if (SMax !== '') generatedName += ` S${SMax}`
    if (SMin !== '') generatedName += `${SMin}`
    if (CMin !== '') generatedName += ` C${CMin}`
    if (SCMax !== '') generatedName += ` S+C${SCMax}`
    if (SCMin !== '') generatedName += `${SCMin}`

    const brandRefRelated = (brandRefOrigin !== oldBrandRefOrigin) ? {
      brandCode: brandRef && brandRef.brandCode,
      key: brandRef && [brandRef.brandCode, orderCode].join('-'),
      name: brandRef && generatedName,
    } : { }

    const orderCodeRelated = (orderCodeOrigin !== oldOrderCodeOrigin) ? {
      key: [brandRef.brandCode, orderCode].join('-'),
    } : { }

    const nameRelated = (
        (refractiveIndexOrigin !== oldRefractiveIndexOrigin) ||
        (designOrigin !== oldDesignOrigin) ||
        (coatingOrigin !== oldCoatingOrigin) ||
        (storageTypeOrigin !== oldStorageTypeOrigin) ||
        (SMaxOrigin !== oldSMaxOrigin) ||
        (SMinOrigin !== oldSMinOrigin) ||
        (CMinOrigin !== oldCMinOrigin) ||
        (SCMaxOrigin !== oldSCMaxOrigin) ||
        (SCMinOrigin !== oldSCMinOrigin)
      ) ? {
        name: generatedName,
      } : { }

    return {
      ...value,
      ...brandRefRelated,
      ...orderCodeRelated,
      ...nameRelated,
    }
  }),

  exposeProps([
    'value',
    'onChange',
  ]),
)(HeadEditorView)

HeadEditor.displayName = 'HeadEditor'

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/products/productsB/HeadEditor/index.js